/**
 * Popper modifer for the arrow element.
 * @param arrowElement the arrow element
 */
export function arrowElementModifier(arrowElement) {
    return { name: 'arrow', options: { element: arrowElement } };
}
/**
 * Popper modifer that allows setting the offset of a popper element
 * @param offset the offset in px
 */
export function offsetModifier(offset) {
    return {
        name: 'offset',
        options: {
            offset: [0, offset],
        },
    };
}
/**
 * Popper modifer that prevent an element from overflowing.
 * @param padding
 */
export function preventOverflowModifier(padding) {
    return { name: 'preventOverflow', options: { padding } };
}
/**
 * Popper modifier that allows the popper element to be the same width as the reference element.
 */
export function sameWidthModifier() {
    return {
        name: 'sameWidth',
        enabled: true,
        phase: 'beforeWrite',
        requires: ['computeStyles'],
        fn: ({ state }) => {
            state.styles.popper.width = `${state.rects.reference.width}px`;
        },
    };
}
//# sourceMappingURL=popperModifiers.js.map